import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// The MUI theme is built dynamically (light/dark) inside the app tree by
// ThemeModeProvider, which reads the user's theme preference. See
// `contexts/ThemeModeContext.js` and `theme.js`. (#159)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
